import { render, staticRenderFns } from "./SendNotification.vue?vue&type=template&id=4cef8ba6"
import script from "./SendNotification.vue?vue&type=script&lang=ts"
export * from "./SendNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports